var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.columns.includes(_vm.prop))?_c('div',{staticClass:"columns category-container"},[_c('div',{staticClass:"column"},[_c('span',{staticClass:"tag is-danger mr-2"},[_vm._v(_vm._s(_vm.model[_vm.prop]))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }